export const DEFAULT_CLINIC_SEARCH_PAGE_SIZE = 15;
